<script setup lang="ts">
import {toTypedSchema} from '@vee-validate/zod'
import FormInput from '../forms/form-input.vue'
import {useField} from 'vee-validate'
import {ZodSchema} from 'zod'

const props = defineProps<{
  name: string
  label?: string
  ariaLabel?: string
  placeholder?: string
  type?: string
  validation?: ZodSchema
  required?: boolean
}>()

const {handleBlur, value, errorMessage, setValue} = useField<string>(
  () => props.name,
  props.validation ? toTypedSchema(props.validation) : undefined
)
</script>

<template>
  <FormInput
    @update:model-value="setValue($event, false)"
    :model-value="value"
    @blur="handleBlur"
    :type="type || 'text'"
    :name="name"
    :label="label"
    :aria-label="ariaLabel"
    :placeholder="placeholder"
    :error="errorMessage"
    :required="required"
  />
</template>
